if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
this.setupFixedZoom();
if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }
setupFixedZoom() {
  const viewer = this.elements.viewer;
  const slider = viewer?.querySelector('[id^="Slider-Gallery-"]');

  if (!slider || viewer.querySelector('.makage-fixed-zoom')) return;

  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'makage-fixed-zoom';
  button.setAttribute('aria-label', 'Sichtbares Produktbild vergrößern');

  button.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg"
      width="20" height="20" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" stroke-width="1.4"
      stroke-linecap="round" aria-hidden="true">
      <circle cx="10.5" cy="10.5" r="6.5"></circle>
      <path d="m16 16 5 5M10.5 7.5v6M7.5 10.5h6"></path>
    </svg>
  `;

  const getVisibleImageButton = () => {
    const viewport = slider.getBoundingClientRect();
    const left = Math.max(viewport.left, 0);
    const right = Math.min(viewport.right, window.innerWidth);

    let bestSlide = null;
    let largestVisibleWidth = 0;

    slider.querySelectorAll('.product__media-item').forEach((slide) => {
      const rect = slide.getBoundingClientRect();
      const visibleWidth = Math.max(
        0,
        Math.min(rect.right, right) - Math.max(rect.left, left)
      );

      if (visibleWidth > largestVisibleWidth) {
        largestVisibleWidth = visibleWidth;
        bestSlide = slide;
      }
    });

    return bestSlide?.querySelector(
      '.product__modal-opener--image button'
    );
  };

  const updateButton = () => {
    button.hidden = !getVisibleImageButton();
  };

  button.addEventListener('click', () => {
  const originalButton = getVisibleImageButton();
  if (!originalButton) return;

  const opener = originalButton.closest('modal-opener');
  const modalSelector = opener?.getAttribute('data-modal');
  if (!modalSelector) return;

  const modal = document.querySelector(modalSelector);
  if (!modal || typeof modal.show !== 'function') return;

  button.setAttribute(
    'data-media-id',
    originalButton.getAttribute('data-media-id')
  );

  modal.show(button);
});

  viewer.appendChild(button);

    // Bild-Klick blockieren; unsere separate Lupe bleibt aktiv.
  viewer.addEventListener('click', (event) => {
    if (this.mql.matches) return;
    if (!(event.target instanceof Element)) return;

    if (event.target.closest('.makage-fixed-zoom')) return;

    if (event.target.closest('.product__modal-opener--image')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  slider.addEventListener('scroll', updateButton, { passive: true });
  requestAnimationFrame(updateButton);
}
      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
